"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.IconEmojiPeople = void 0;
const react_1 = __importDefault(require("react"));
const Icon_1 = require("./Icon");
// Material Icon
// https://material.io/resources/icons/?search=people&icon=emoji_people&style=baseline
const IconEmojiPeople = (props) => {
    return (react_1.default.createElement(Icon_1.SVGIcon, { ...props, size: props.size },
        react_1.default.createElement("g", null,
            react_1.default.createElement("rect", { fill: "none", height: "24", width: "24" })),
        react_1.default.createElement("g", null,
            react_1.default.createElement("g", null),
            react_1.default.createElement("g", null,
                react_1.default.createElement("circle", { cx: "12", cy: "4", r: "2" }),
                react_1.default.createElement("path", { d: "M15.89,8.11C15.5,7.72,14.83,7,13.53,7c-0.21,0-1.42,0-2.54,0C8.24,6.99,6,4.75,6,2H4c0,3.16,2.11,5.84,5,6.71V22h2v-6h2 v6h2V10.05L18.95,14l1.41-1.41L15.89,8.11z" })))));
};
exports.IconEmojiPeople = IconEmojiPeople;
